import Footer from '@bridebook/web/app-basic/components/footer/footer';
import Head from '@bridebook/web/app-basic/components/head/head';
import { TopBar } from '@bridebook/web/app-basic/components/header';
import SearchSuppliers from '@bridebook/web/app-basic/components/search-suppliers/search-suppliers';
import { memo } from 'react';
import type { Slug } from '@bridebook/toolbox/src/types';
import { SearchSuppliersContextProvider } from '@bridebook/web/app-basic/components/search-suppliers/search-suppliers.context';
import { SearchSuppliersPageProps } from '@bridebook/web/app-shared/lib/search-suppliers/types';

const SearchSuppliersPageComponent = ({
  generic,
  specific,
  typeSpecific,
  slug,
  topCountiesPerCountry,
  topTypes,
}: SearchSuppliersPageProps) => (
  <>
    <Head title={specific?.title} description={specific?.meta} robots="all" />
    <TopBar />
    <SearchSuppliersContextProvider
      value={{
        specific,
        generic,
        typeSpecific,
        slug: slug as Slug,
        topCountiesPerCountry,
        topTypes,
      }}>
      <SearchSuppliers />
    </SearchSuppliersContextProvider>
    <Footer />
  </>
);

export const SearchSuppliersPage = memo(SearchSuppliersPageComponent);
